import { appDateTime, appWeekdayTime } from "../../src/app-dates.ts";
import type { InboxThread } from "../../src/inbox-v2/contract.ts";
import type { Assignment } from "./assignment.tsx";

/** Both actors come from the Assign menu's workspace population, never from a raw id. */
export function HandoverMeta(props: { thread: InboxThread; assignment: Assignment | null }) {
  const { thread, assignment } = props;
  const actor = (id: string | null): string | null => {
    const person = assignment?.people.find((candidate) => candidate.userId === id);
    return person ? (person.userId === assignment?.you ? "you" : person.name) : null;
  };
  const record = thread.assignmentRecord;
  const snooze = thread.handoverSnooze;
  const assignedBy = record ? actor(record.assignedBy) : null;
  const snoozedBy = snooze ? actor(snooze.by) : null;
  if (!record && !snooze) return null;
  const verb = thread.assignment?.assignee ? "Assigned" : "Unassigned";
  const assignmentWords =
    record?.source === "rule"
      ? "Assigned by mailbox group,"
      : assignedBy
        ? `${verb} by ${assignedBy},`
        : verb;
  return (
    <p className="lcr-i2-handover">
      {record && (
        <span>
          {assignmentWords}{" "}
          <time dateTime={record.assignedAt}>{appDateTime(record.assignedAt)}</time>
        </span>
      )}
      {snooze && (
        <span>
          Snoozed{snoozedBy ? ` by ${snoozedBy}` : ""} until{" "}
          <time dateTime={snooze.until}>{appWeekdayTime(snooze.until)}</time>
        </span>
      )}
    </p>
  );
}
